/**
 * O título da missão, na língua do jogador.
 *
 * O servidor guarda o título da missão em inglês no catálogo ("Catch 26 fish") e o cliente sempre
 * o imprimiu cru — o quadro do Cais e o modal de missões falavam inglês num jogo em português.
 * Para os tipos quantitativos o título é derivável do próprio dado (`tipo` + objetivo), então a
 * tradução acontece aqui; o que não é derivável (ex.: `specificFish`, cujo título carrega o nome
 * do peixe) cai no título do servidor, que é melhor que uma chave crua.
 */
export function tituloDaMissao(missao, t) {
  const chave = `dailyMissions.tipos.${missao.type}`;

  // `specificFish` carrega o peixe no título ("Catch Tilápia") — o nome sai de lá e passa pelo
  // dicionário de peixes que o jogo já tem.
  let peixe = '';
  if (missao.type === 'specificFish' && missao.title) {
    const nome = missao.title.replace(/^Catch\s+/i, '');
    const chaveDoPeixe = `fishes.${nome}`;
    const traduzidoPeixe = t(chaveDoPeixe);
    peixe = traduzidoPeixe === chaveDoPeixe ? nome : traduzidoPeixe;
  }

  const traduzido = t(chave, { n: missao.amountRequired, peixe });
  return traduzido === chave ? missao.title : traduzido;
}

export default tituloDaMissao;
